module.exports = __webpack_public_path__ + "img/neudorf-reviews.d0be66ce.webp";